/* eslint-disable @vp/swan/no-deprecated -- we will need to update to AdaptiveCarousel */
import React from 'react';

import { ThumbnailsHeroVideoThumbnailSlide, FluidImage } from '@vp/swan';
import { useLocalizations } from '@vp/ubik-localizations-provider';

import { buildKeyboardEventHandler } from '../../libs/keyboardEventHandlerBuilder';

import { ThumbnailMediaSlideProps } from './ThumbnailMediaSlideProps';

export const ThumbnailVideoSlide: React.FC<ThumbnailMediaSlideProps> = (
  props: ThumbnailMediaSlideProps
) => {
  const { t } = useLocalizations();
  const handleOnClick = () => props.onClickHandler(props.slide.position);

  return (
    <ThumbnailsHeroVideoThumbnailSlide
      role="button"
      tabIndex={0}
      onKeyDown={buildKeyboardEventHandler(handleOnClick)}
      aria-label={props.slide.getThumbnailAriaLabel(t)}
      onClick={handleOnClick}
    >
      <FluidImage src={props.slide.thumbnail} alt={props.slide.getAlt(t)} />
    </ThumbnailsHeroVideoThumbnailSlide>
  );
};
